import React from "react"

const styleSheet = theme => ({
  root: {
    padding: [theme.spacing.unit, theme.spacing.unit / 2, theme.spacing.unit * 2],
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },

  action: {
    margin: [0, theme.spacing.unit / 2],
  },
})

function ComponentErrorActions({
  classes,
  children,

  ...otherProps
}) {
  return (
    <div {...otherProps} className={classes.root}>
      {React.Children.map(children, c => <div className={classes.action}>{c}</div>)}
    </div>
  )
}

import withStyles from "@material-ui/core/styles/withStyles"
export default withStyles(styleSheet)(ComponentErrorActions)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-ComponentError/ComponentErrorActions.js